import { RefreshHttpClient } from "@clairejs/client";
import { AccessToken, Errors } from "@clairejs/core";

export class ApiClient extends RefreshHttpClient {
    public sessionExpiredCallback?: () => void;
    public tfaRequiredCallback?: () => Promise<void>;

    protected async errorHandler<T = any>(operation: () => Promise<T>, err: any): Promise<T | undefined> {
        try {
            return await super.errorHandler(operation, err);
        } catch (e: any) {
            if (e.name === Errors.SESSION_EXPIRED().name && this.sessionExpiredCallback) {
                this.sessionExpiredCallback();
                return undefined;
            }

            if (e.name === Errors.TFA_REQUIRED().name && this.tfaRequiredCallback) {
                return await this.tfaRequiredCallback().then(operation);
            }

            throw e;
        }
    }

    protected async refreshSession(refreshToken: string): Promise<AccessToken | undefined> {
        const result = await this.post<{ accessToken?: AccessToken }>(
            "/session/refresh",
            {
                refreshToken,
            },
            {},
            { noAuthorization: true, noErrorHandling: true },
        );

        return result?.accessToken;
    }
}
